<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import SettingsTabs from './SettingsTabs.vue';

defineProps({
  keepAlive: {
    type: Boolean,
    default: true,
  },
});

const route = useRoute();
const showsAccountSettingsTabs = computed(() =>
  route.path.includes('/settings/')
);
</script>

<template>
  <div
    class="medup-settings-page flex flex-col w-full min-w-0 h-full m-0 overflow-auto bg-[#f4f4f4] font-inter text-[#27283e] [--slate-12:39_40_62] [--slate-11:71_72_82] [--border-weak:229_229_232] dark:bg-n-background dark:text-n-slate-12 dark:[--slate-12:245_243_255] dark:[--slate-11:185_195_211] dark:[--border-weak:49_56_78]"
  >
    <SettingsTabs v-if="showsAccountSettingsTabs" />

    <div class="medup-settings-content w-full min-w-0 px-3 pt-4 pb-6 sm:px-6">
      <div
        class="medup-settings-surface flex items-start w-full min-w-0 min-h-[calc(100vh-220px)] mx-auto p-4 sm:p-6 rounded-xl border border-[#27283e]/[0.12] bg-white/[0.92] shadow-[0_1px_2px_rgba(15,23,42,0.04),0_8px_24px_rgba(31,55,95,0.05)] dark:border-n-weak dark:bg-n-surface-1 [&>*]:w-full [&_*]:scroll-mt-4 [&_h1]:text-xl [&_h1]:font-bold [&_h1]:tracking-[-0.3px] [&_h4]:text-[15px] [&_h4]:font-semibold [&_input.reset-base]:bg-white [&_input.reset-base]:rounded-lg [&_select]:min-h-9 [&_select]:rounded-lg [&_select]:border [&_select]:border-n-weak [&_select]:bg-white [&_select]:py-1.5 [&_select]:pl-3 [&_select]:pr-8 [&_select]:text-[13px] [&_select]:text-n-slate-12 [&_select]:transition-colors [&_select:focus]:border-n-brand dark:[&_input.reset-base]:bg-n-surface-2 dark:[&_select]:bg-n-surface-2"
      >
        <router-view v-slot="{ Component }">
          <keep-alive v-if="keepAlive">
            <component :is="Component" :key="route.fullPath" />
          </keep-alive>
          <component :is="Component" v-else :key="route.fullPath" />
        </router-view>
      </div>
    </div>
  </div>
</template>
